import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import {
  Form,
  Input,
  Upload,
  Button,
  Switch,
  Select,
  Row,
  Col,
  Tabs,
  Flex,
  Modal,
  Space,
  Table,
  TableProps,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  PlusCircleFilled,
  PlusCircleOutlined,
  SearchOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import {
  addGroup,
  FetchGroupList,
  updateGroup,
  FetchEquipmentList,
} from "../../redux/actions/action";
import styles from "./AddGroupPopup.module.css";
import { v4 as uuidv4 } from "uuid";
import tool from "../../assets/icons/tool.svg";
import aperture from "../../assets/icons/aperture.svg";
import location from "../../assets/icons/location1.svg";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

function AddGroupPopup(props) {
  const [allPartGroupList, setAllPartGroupList] = useState([]);
  const [groupName, setGroupName] = useState("");
  const [editingGroup, setEditingGroup] = useState(null);
  const [groupPartList, setGroupPartList] = useState([]);

  const dispatch = useDispatch();

  const equipmentPartList = useSelector((state) => state.user.equipmentList);

  useEffect(() => {
    dispatch(FetchEquipmentList());
  }, []);

  useEffect(() => {
    const partListArray = equipmentPartList.map((asset) => {
      return {
        partId: asset.assetId,
        type: asset.assetType,
        name: asset.assetName,
        quantity: 0, // Set default values as needed
        unitCost: 0,
        totalCost: 0,
      };
    });
    setAllPartGroupList(partListArray);
  }, [equipmentPartList]);

  useEffect(() => {
    if (props.groupList && props.groupList.length) {
      // If editingGroupId is provided, set the editingGroup state

      setEditingGroup(props.groupList[0]);
      setGroupName(props.groupList[0].groupName);
      setGroupPartList(props.groupList[0].parts);
    } else {
      setEditingGroup(null);
      setGroupName("");
      setGroupPartList([]);
    }
  }, [props.groupList]);

  const handleDragEnd = async (result) => {
    if (!result.destination) {
      // Dragged outside the list
      return;
    }

    // Extract the actual partId from the draggableId
    const draggedPartId = result.draggableId;
    const draggedItem1 = allPartGroupList?.find(
      (part) => `column1-${part.partId}` === draggedPartId
    );
    const draggedItem2 = groupPartList?.find(
      (part) => `column2-${part.partId}` === draggedPartId
    );

    if (draggedItem1 || draggedItem2) {
      if (result.destination.droppableId === "column1") {
        // Move item from groupPartList to allPartGroupList
        const draggedItem = groupPartList?.find(
          (part) => `column2-${part.partId}` === draggedPartId
        );
        const updatedGroupPartList = groupPartList?.filter(
          (part) => `column2-${part.partId}` !== draggedPartId
        );
        draggedItem.disabled = false;
        setGroupPartList(updatedGroupPartList);

        // Add the dragged item to allPartGroupList
        // setAllPartGroupList(prevList => [...prevList, draggedItem]);
      } else {
        // Move item from allPartGroupList to groupPartList
        const draggedItem = allPartGroupList?.find(
          (part) => `column1-${part.partId}` === draggedPartId
        );
        const updatedPartList = allPartGroupList?.filter(
          (part) => `column1-${part.partId}` !== draggedPartId
        );
        draggedItem.disabled = true; // Add the disabled property
        // setAllPartGroupList(updatedPartList);

        // Wait for the state to be updated before logging
        await setGroupPartList((prevList) => [...prevList, draggedItem]);
      }
    } else {
      // console.error("Dragged item not found.");
    }
  };

  const handleAddOrUpdateGroup = () => {
    const groupData = {
      groupId: editingGroup ? editingGroup.groupId : uuidv4(),
      groupName: groupName,
      parts: groupPartList,
      partsCount: groupPartList.length,
    };

    if (editingGroup) {
      // If editing, dispatch the updateGroup action
      dispatch(updateGroup(groupData));
    } else {
      // If adding, dispatch the addGroup action
      dispatch(addGroup(groupData));
    }

    // Fetch the updated group list
    setTimeout(() => {
      dispatch(FetchGroupList());

      // Reset the state
      setGroupName("");
      setGroupPartList([]);
      setEditingGroup(null);

      const updatedList = allPartGroupList.map((item) => ({
        ...item,
        disabled: false,
      }));

      setAllPartGroupList(updatedList);
    }, 200);
    // setAllPartGroupList(allpartList)
    // Close the popup
    props.cancelEvent();
  };

  const getImageSource = (type) => {
    // Add your logic to map part types to image sources
    switch (type) {
      case "Equipment":
        return aperture;
      case "Part":
        return tool;
      case "Facility":
        return location;
      // Add more cases as needed
    }
  };

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Assets-Add").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  return (
    <>
      <div
        className={`${styles.addGroup_popup} ${
          props.modalOpen ? styles.show : ""
        }`}
      >
        <div className={styles.popup_inner}>
          <div className={styles.popup_content}>
            <div className={styles.popup_header}>
              <Flex gap="small" className={styles.flex}>
                <div className={styles.title_input_wrap}>
                  <label>
                    {/* Group Name */}
                    {t("Group Name")}
                  </label>
                  <input
                    type="text"
                    id="GroupName"
                    placeholder="Add a name"
                    value={groupName}
                    required
                    onChange={(e) => setGroupName(e.target.value)}
                  />
                </div>
                <div className={styles.btn_wrap}>
                  <button
                    type="button"
                    id="cancelButton"
                    className={styles.btn_cancel}
                    onClick={props.cancelEvent}
                  >
                    {/* Cancel */}
                    {t("Cancel")}
                  </button>
                  <button
                    type="button"
                    className={styles.btn_add}
                    onClick={handleAddOrUpdateGroup}
                  >
                    {/* {editingGroup ? "Update" : "Add"} */}
                    {editingGroup ? "Update" : t("Add")}
                  </button>
                </div>
              </Flex>
            </div>
            <div className={styles.popup_body}>
              <div className={styles.group_wrapper}>
                <DragDropContext onDragEnd={handleDragEnd}>
                  <Row className={styles.group_row}>
                    <Col flex={2} className={styles.part_list_col}>
                      <Droppable droppableId="column1">
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className={styles.col_inner}
                          >
                            <div className={styles.col_header}>
                              <Flex gap="small" className={styles.flex}>
                                <h2>
                                  {/* Equipments & Parts */}
                                  {t("Equipments & Parts")}
                                </h2>
                                <div className={styles.search_input}>
                                  <input type="text" placeholder="Search" />
                                  <Button
                                    type="text"
                                    shape="circle"
                                    icon={<SearchOutlined />}
                                  />
                                </div>
                              </Flex>
                            </div>

                            <div className={styles.col_content_wrapper}>
                              <div className={styles.part_listing_wrapper}>
                                {allPartGroupList.map((parts, index) => (
                                  <Draggable
                                    key={parts.partId}
                                    draggableId={`column1-${parts.partId}`}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className={`${
                                          styles.part_list_single
                                        } ${
                                          parts.disabled ? styles.disable : ""
                                        }`}
                                      >
                                        <div className={styles.list_icon}></div>
                                        <div className={styles.icon_text}>
                                          <div className={styles.icon_wrap}>
                                            <img
                                              src={getImageSource(parts.type)}
                                              alt="part icon"
                                            />
                                          </div>
                                          {parts.name}
                                        </div>
                                        <div className={styles.list_text}>
                                          {parts.name}
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                ))}
                              </div>
                              {provided.placeholder}
                            </div>
                          </div>
                        )}
                      </Droppable>
                    </Col>
                    <Col flex={3} className={styles.group_part_col}>
                      <Droppable droppableId="column2">
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className={styles.col_inner}
                          >
                            <div className={styles.col_header}>
                              <h2>
                                {/* Group Parts */}
                                {t("Group Parts")}
                              </h2>
                            </div>
                            <div className={styles.col_content_wrapper}>
                              <div className={styles.part_listing_wrapper}>
                                {groupPartList?.map((groupPart, index) => (
                                  <Draggable
                                    key={groupPart.partId}
                                    draggableId={`column2-${groupPart.partId}`}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className={styles.part_list_single}
                                      >
                                        <div className={styles.list_icon}></div>
                                        <div className={styles.icon_text}>
                                          <div className={styles.icon_wrap}>
                                            <img
                                              src={getImageSource(
                                                groupPart.type,
                                              )}
                                              alt="part icon"
                                            />
                                          </div>
                                          {groupPart.name}
                                        </div>
                                        <div className={styles.qut_input}>
                                          <input
                                            type="number"
                                            placeholder="0"
                                            defaultValue={groupPart.quantity}
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                ))}
                              </div>
                              {provided.placeholder}
                            </div>
                          </div>
                        )}
                      </Droppable>
                    </Col>
                  </Row>
                </DragDropContext>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// export default connect(mapStateToProps, mapDispatchToProps)(GroupListPopup);
export default AddGroupPopup;
